import { render, staticRenderFns } from "./improper.vue?vue&type=template&id=25a0ba85&"
import script from "./improper.vue?vue&type=script&lang=js&"
export * from "./improper.vue?vue&type=script&lang=js&"
import style0 from "./improper.vue?vue&type=style&index=0&id=25a0ba85&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports